import opera360Banner from "@/assets/integrations/opera360_api.png";
import servicenowBanner from "@/assets/integrations/servicenow.png";
import vivoGestaoLogo from "@/assets/integrations/vivo-gestao.png";

export const INTEGRATION_ASSETS = {
  opera360: { src: opera360Banner, displayMode: "banner" },
  servicenow: { src: servicenowBanner, displayMode: "banner" },
  vivo_gestao: { src: vivoGestaoLogo, displayMode: "logo" },
};

export function getIntegrationAsset(slug) {
  return INTEGRATION_ASSETS[slug] || null;
}

export function getIntegrationLogo(slug) {
  const asset = getIntegrationAsset(slug);
  return asset ? asset.src : null;
}
